import { createDateFormatter } from '@dreryk/react-common';
import { colorsMatrix } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../../translations';

export const CHART_ELEMENTS = 14;
export const CHART_CHUNK_SIZE = 7;
export const CHART_COLORS = [colorsMatrix.yellow.basic, colorsMatrix.blue.basic];
export const CHART_LEGEND_LABELS = [
   dashboardTranslationKeys.cards.previousWeek,
   dashboardTranslationKeys.cards.currentWeek,
];

// TODO: DREGAB-22880 - walidator w react-common + testy
export const longWeekdayDayMonthFormatter = createDateFormatter(() => ({
   weekday: 'long',
   day: '2-digit',
   month: 'long',
}));
